// Info and Warning box components

import React from 'react';
import Icon from '../../../core/Icon';
import { InfoBoxContainer, WarningBoxContainer } from '../styles';

export const InstructionsBox: React.FC = () => (
  <InfoBoxContainer>
    <strong>How to use:</strong>
    <br />
    1. Click &quot;Initialize Gateways&quot; to create test gateways for all rooms.
    <br />
    2. Click &quot;Create Test Patients&quot; to create 5 test patients with procedures scheduled for today and assign
    bracelets.
    <br />
    3. Click a beacon on the left, then click a room on the right to move it there.
    <br />
    4. Click &quot;Start Simulation&quot; to begin sending beacon signals.
    <br />
    5. View patients on Schedule, OR Tablet, Internal Monitor, or Kiosk screens.
  </InfoBoxContainer>
);

interface StatusMessageBoxProps {
  message: string;
}

export const StatusMessageBox: React.FC<StatusMessageBoxProps> = ({ message }) => {
  const isError = message.startsWith('Error');
  return <InfoBoxContainer variant={isError ? 'error' : 'success'}>{message}</InfoBoxContainer>;
};

export const WarningBox: React.FC = () => (
  <WarningBoxContainer>
    <Icon className="material-icons" style={{ fontSize: '1.2rem', color: '#FF9800' }}>
      warning
    </Icon>
    Only one person should use this tool at a time. Multiple users will cause conflicting signals.
  </WarningBoxContainer>
);
